/**
 * The federation router strips GraphQL error `extensions`, so the backend
 * repeats each rejected answer in the message text as "<index>: <reason>".
 * This pulls those pairs out so the form can flag the affected fields; the
 * full message is still toasted for anything this misses.
 */
export const extractAnswerErrors = (
    message: string | null | undefined,
    knownIndices: ReadonlyArray<string>,
): Record<string, string> => {
    const result: Record<string, string> = {};
    if (!message) return result;

    const hits = knownIndices
        .map((index) => {
            const match = new RegExp(`(^|[^A-Za-z0-9_])${index}:\\s*`).exec(message);
            return match ? { index, start: match.index + match[1].length, contentStart: match.index + match[0].length } : null;
        })
        .filter((hit): hit is { index: string; start: number; contentStart: number } => hit !== null)
        .sort((a, b) => a.start - b.start);

    hits.forEach((hit, i) => {
        const end = i + 1 < hits.length ? hits[i + 1].start : message.length;
        const reason = message.slice(hit.contentStart, end).trim().replace(/[;,.\s]+$/, '');
        if (reason) result[hit.index] = reason;
    });
    return result;
};
